import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'reactstrap';
import { createSignatureImageFromText } from '~/helpers/signatureTextCanvas';

type TDocViewerSignTextProps = {
  signatureType: number;
  closeHandler: () => void;
  isActive: boolean;
  applySignatures: (data: string, signatureType: number) => void;
}

const DocViewerSignText = (props: TDocViewerSignTextProps) => {

  /**
   * Component props:
   * signatureType {number} the signature type
   * closeHandler {func} callback to call in order to dismiss the modal
   * isActive {boolean} TRUE if the typing tab is the active tab
   */
  const { signatureType, closeHandler, isActive, applySignatures } = props;

  /**
   * Ref to the input dom object (for font-family and focus)
   */
  const input: any = useRef(null);

  /**
   * Stores the text the user has typend into the text box
   */
  const [signature, setSignature] = useState('');

  /**
   * This effect runs whenever the tab is activated/deactivated
   * We use it to auto-focus the input field
   */
  useEffect(() => {
    // abort if the tab has just been deactivated
    if (!isActive) {
      return;
    }
    // focus the input field
    input.current.setSelectionRange(signature.length, signature.length);
    input.current.focus();
  }, [isActive]);

  /**
   * Event handler called when the user clicks the 'Apply' button.
   * Uses the same canonical signature image as manual sign; backend scales when placing on each field.
   */
  const applySignature = () => {
    const fontFamily = window.getComputedStyle(input.current).getPropertyValue('font-family');
    const data = createSignatureImageFromText(signature, fontFamily);
    applySignatures(data, signatureType);
  }

  return <React.Fragment>
    <div className="doc-viewer-sign-text">
      <Input innerRef={input} type="text" className="form-control sign-text-field" placeholder="Type here" onChange={e => setSignature(e.target.value)} value={signature} />
    </div>
    <div className="modal-footer">
      <Button type="button" color="primary" onClick={applySignature} data-dismiss="modal" disabled={!signature}>Apply</Button>
      <Button type="button" color="secondary" onClick={closeHandler} data-dismiss="modal">Close</Button>
    </div>
  </React.Fragment>
}

DocViewerSignText.propTypes = {
  signatureType: PropTypes.number,
  closeHandler: PropTypes.func,
  isActive: PropTypes.bool,
  applySignatures: PropTypes.func,
}

export default DocViewerSignText;